export default __webpack_public_path__ + "static/media/menu-btn.ee40538e.svg";